import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ApplicationConfigService } from './core/config/application-config.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { fontAwesomeIcons } from './config/font-awesome-icons';
import dayjs from 'dayjs/esm';
import { RouterOutlet } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { appConfig } from './app.config';

import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { SharedLibsModule } from './shared/shared-libs.module';
import { RxStompEventAction, RxStompService } from './core/socket/RxStompService.service';

@NgModule({
	imports: [BrowserAnimationsModule, SharedLibsModule, BrowserModule, RouterOutlet],
	providers: appConfig.providers,
	declarations: [AppComponent],
	bootstrap: [AppComponent],
})
export class AppModule {
	constructor(
		applicationConfigService: ApplicationConfigService,
		iconLibrary: FaIconLibrary,
		dpConfig: NgbDatepickerConfig,
		rxStompService: RxStompService
	) {
		rxStompService.doEvent(RxStompEventAction.INITIAL);
		applicationConfigService.setEndpointPrefix(SERVER_API_URL);
		registerLocaleData(localePt);
		iconLibrary.addIcons(...fontAwesomeIcons);
		dpConfig.minDate = { year: dayjs().subtract(100, 'year').year(), month: 1, day: 1 };
	}
}
